export default __webpack_public_path__ + "static/media/EMprint Regular.ad5d362f.ttf";